export default __webpack_public_path__ + "static/media/G0001.a4f45d2a.png";